import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

const persistedLang = localStorage.getItem("persist:root");
let initialLang = "en";

try {
  if (persistedLang) {
    const parsed = JSON.parse(persistedLang);
    const language = JSON.parse(parsed.language)?.language;
    if (language) {
      initialLang = language;
    }
  }
} catch (e) {
  console.warn("Could not load language from persisted store:", e);
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
  },
  lng: initialLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
